'use client';
import { useEffect } from 'react';
import { clarity } from 'react-microsoft-clarity';

export default function ClarityAnalytics() {
    useEffect(() => {

        // Only run in production and client-side
        if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
        // if(typeof window !== 'undefined'){
            console.log("clarity start")
            // Initialize Clarity
            clarity.init(process.env.REACT_APP_CLARITY_ID);
            // const clarityId = process.env.REACT_APP_CLARITY_ID;
            
            
            // if (clarityId) {
            //     console.log("Initializing Clarity with ID:", clarityId);
            // }
            // else{
            //     console.error("Clarity ID is not defined. Check your .env.local file.");
            // }

            // Set up default tags
            clarity.setTag("environment", process.env.NODE_ENV);

            // Setup consent (you can tie this to your cookie consent logic)
            clarity.consent();

            // Example of identifying users (modify based on your auth logic)
            if (clarity.hasStarted()) {
                // You can add user identification logic here
                // clarity.identify('USER_ID', { userProperty: 'value' });
            }

            // Example of setting up custom events
            clarity.setEvent("app_loaded");
        }
        // }

        // Cleanup function
        return () => {
            // console.log("working clarity")
            if (clarity.hasStarted()) {
                clarity.stop();
            }
        };
    }, []);

    // This component doesn't render anything
    return null;
} 